<template>

    <div class="travel-package">
        <div>
            <TravelPackageComponent />
        </div>
    </div>

</template>

<script>
import TravelPackageComponent from '@/components/TravelPackage/TravelPackageComponent.vue';
export default {
    components: {
        TravelPackageComponent,
    },
    data() {
        return {
            // loading: true,
        }
    },
    method: {

    },
    created() {
        // this.loading = false
    }
}
</script>
<style scoped></style>